import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'configurationsPage',
  templateUrl: './configurationsPage.component.html',
  styleUrls: ['./configurationsPage.component.css']
})
export class ConfigurationsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
